export abstract class BaseListPage {
	constructor(
	){
		this.working = {
			isWorking: false,
			action: ''
		};
	}

	working: {
		isWorking: boolean,
		action: any
	}

	isWorking(){
		return this.working.isWorking;
	}	

	isWorkingByAction(action){
		return this.working.isWorking && this.working.action == action;
	}		

	startWorking(action){
		this.working = {
			isWorking: true,
			action: action
		};
	}

	stopWorking(){
		this.working = {
			isWorking: false,
			action: ""
		};		
	}	
		
	items: any = [];	
	hasItems: boolean = false;
	loader: any;
	filterCategory: any;
	page: any = 1;
	size: any = 20;

	loadingMsg: any = "Loading...";
	isRefreshing: boolean = false;
	isFetchingMore: boolean = false;
	isLoading: boolean = false;
	lastRequestReturnedValues: boolean = false;	

	params: any = {
		page: 1,
		size: 10,
		id: null,
		cbAfter: null,
		cb: (items)=>{
			this.isLoading = false;

			this.hasItems = (items.length == 0 && this.params.page == 1) ? false : true;

			this.lastRequestReturnedValues = (items.length==0) ? false : true;

			if(this.params.page == 1){
				this.items = items;	
			}else{
				for (var i = items.length - 1; i >= 0; i--) {
					this.items.push(items[i]);
				}	
			}
			
			this.isLoading = false;

			if(typeof this.params.cbAfter == "function")
				this.params.cbAfter()			
		}
	};
};


// WEBPACK FOOTER //
// ./src/providers/base-list-page.ts